module.exports = __webpack_public_path__ + "media/images/icons/fullname_icon-8f14a5c0191f995a147da7db58ae4aee.svg";